export const currency = (value) => {
  let formatted;
  if (value === 0 || value === '0') {
    return 'R$ 0,00';
  }
  if (value) {
    const cleanValue =
      typeof value === 'string' && value.includes(',')
        ? value.replace(/\./g, '').replace(',', '.')
        : value;
    const numberValue = Number(cleanValue);

    if (Number.isNaN(numberValue)) return value;

    formatted = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(numberValue);
  }
  return formatted;
};
